import { render, staticRenderFns } from "./SncMerchRecipients.vue?vue&type=template&id=6fd1fe88"
import script from "./SncMerchRecipients.vue?vue&type=script&lang=ts"
export * from "./SncMerchRecipients.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports